export const CONTACTS = {
  email: "info@montepcservice.it",
  phoneFixed: "0571-1730281",
  phoneFixedHref: "tel:+3905711730281",
  mobile: "331-3289902",
  mobileHref: "tel:+393313289902",
  whatsapp: "https://wa.me/393313289902",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1721332154191-ba5f1534266e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxjb21wdXRlciUyMHJlcGFpciUyMGhhcmR3YXJlJTIwdGVjaG5pY2lhbiUyMHdvcmtzdGF0aW9uJTIwbW90aGVyYm9hcmQlMjBzb2xkZXJpbmd8ZW58MHx8fHwxNzg5NDQ4MDI2fDA&ixlib=rb-4.1.0&q=85",
  workbench:
    "https://images.unsplash.com/photo-1721333091889-0b4fe5b2b28f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxjb21wdXRlciUyMHJlcGFpciUyMGhhcmR3YXJlJTIwdGVjaG5pY2lhbiUyMHdvcmtzdGF0aW9uJTIwbW90aGVyYm9hcmQlMjBzb2xkZXJpbmd8ZW58MHx8fHwxNzg5NDQ4MDI2fDA&ixlib=rb-4.1.0&q=85",
  rack: "/images/voip-process.webp",
  server: "/images/server-rack.png",
  smartphone:
    "https://images.unsplash.com/photo-1633250391894-397930e3f5f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxzbWFydHBob25lJTIwY29uZmlndXJhdGlvbiUyMG1vYmlsZSUyMHNjcmVlbiUyMHRlc3RpbmclMjBzZXR1cHxlbnwwfHx8fDE3ODk0NDgwMzF8MA&ixlib=rb-4.1.0&q=85",
  webdev:
    "https://images.unsplash.com/photo-1630442923896-244dd3717b35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxzbWFydHBob25lJTIwY29uZmlndXJhdGlvbiUyMG1vYmlsZSUyMHNjcmVlbiUyMHRlc3RpbmclMjBzZXR1cHxlbnwwfHx8fDE3ODk0NDgwMzF8MA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
  "Riparazione & Reinstallazione PC",
  "Reti e Impianti Fonia/Dati",
  "Sviluppo Siti Internet",
  "Configurazione Smartphone",
  "Consulenza Piani Tariffari",
  "Assistenza Server & Software",
];

export const SERVICES = [
  {
    number: "01",
    title: "Riparazione & Reinstallazione PC",
    description:
      "Diagnosi, riparazione e reinstallazione di PC desktop e portatili. Aggiorno hardware e software, elimino virus e rallentamenti, e ridò vita a macchine ferme da anni.",
    highlights: ["Diagnostica approfondita", "Sostituzione SSD & RAM", "Recupero dati & backup", "Installazione pulita del sistema"],
    image: IMAGES.workbench,
    alt: "Postazione di lavoro per riparazione hardware PC",
  },
  {
    number: "02",
    title: "Progettazione Reti & Impianti Fonia/Dati",
    description:
      "Studio e realizzo reti cablate e Wi-Fi per case e aziende: cablaggio strutturato, armadi rack, impianti di fonia e copertura wireless senza zone morte.",
    highlights: ["Cablaggio strutturato", "Copertura Wi-Fi completa", "Configurazione router & firewall", "Impianti di fonia"],
    image: IMAGES.rack,
    alt: "Schema di funzionamento di un impianto VoIP: telefono, adattatore, modem e internet",
    contain: true,
  },
  {
    number: "03",
    title: "Sviluppo Siti Internet",
    description:
      "Progetto e sviluppo siti web veloci, moderni e responsive per professionisti e attività locali. Dalla vetrina al sito completo, sempre su misura.",
    highlights: ["Siti vetrina su misura", "Design responsive", "Visibilità sui motori", "Dominio & hosting gestiti"],
    image: IMAGES.webdev,
    alt: "Sviluppo e ottimizzazione di siti internet",
  },
  {
    number: "04",
    title: "Configurazione Smartphone & Tablet",
    description:
      "Mi occupo della parte software di cellulari e smartphone: configurazione, reset sicuro, ampliamento memoria e aggiornamenti. Non tratto riparazioni hardware come vetri o display.",
    highlights: ["Trasferimento foto e contatti", "Reset e ripristino", "Configurazione email & app", "Ampliamento memoria"],
    image: IMAGES.smartphone,
    alt: "Configurazione software di smartphone e account",
  },
  {
    number: "05",
    title: "Consulenza Piani Tariffari",
    description:
      "Analizzo le tue bollette di telefono e internet e ti indirizzo verso gli operatori e le offerte che si confanno davvero alle tue esigenze, senza costi nascosti.",
    highlights: ["Verifica copertura fibra/5G", "Confronto tariffe reali", "Supporto cambio operatore", "Nessun vincolo con gli operatori"],
    customPanel: true,
  },
  {
    number: "06",
    title: "Assistenza Software & Server",
    description:
      "Assistenza continuativa su prodotti software e sistemi server per privati e aziende: manutenzione, backup, sicurezza e supporto da remoto o in sede.",
    highlights: ["Assistenza remota e in sede", "Gestione server e NAS", "Backup e ripristino", "Manutenzione programmata"],
    image: IMAGES.server,
    alt: "Assistenza e verifica su sistemi server",
  },
];

export const SERVICE_OPTIONS = [...SERVICES.map((s) => s.title), "Altro / Richiesta generica"];

export const DIAGNOSTIC = {
  "PC Desktop": {
    "Non si accende": { prezzo: "da 40€ a 90€", tempo: "1–2 giorni lavorativi" },
    "Molto lento / si blocca": { prezzo: "da 35€ a 70€", tempo: "spesso in giornata" },
    "Virus o malware": { prezzo: "da 40€ a 80€", tempo: "1 giorno lavorativo" },
    "Aggiornamento hardware (SSD/RAM)": { prezzo: "da 50€ + componenti", tempo: "1–2 giorni lavorativi" },
  },
  Notebook: {
    "Non si accende": { prezzo: "da 45€ a 100€", tempo: "1–3 giorni lavorativi" },
    "Molto lento / si blocca": { prezzo: "da 35€ a 70€", tempo: "spesso in giornata" },
    "Sostituzione SSD / RAM": { prezzo: "da 50€ + componenti", tempo: "1–2 giorni lavorativi" },
    "Reinstallazione completa": { prezzo: "da 50€ a 90€", tempo: "1 giorno lavorativo" },
  },
  "Smartphone / Tablet": {
    "Configurazione iniziale": { prezzo: "da 25€ a 45€", tempo: "circa 1 ora" },
    "Trasferimento dati": { prezzo: "da 30€ a 50€", tempo: "1–2 ore" },
    "Reset e ripristino": { prezzo: "da 25€ a 45€", tempo: "circa 1 ora" },
    "Memoria piena / aggiornamenti": { prezzo: "da 25€ a 50€", tempo: "circa 1 ora" },
  },
  "Rete / Wi-Fi": {
    "Copertura Wi-Fi insufficiente": { prezzo: "sopralluogo gratuito", tempo: "preventivo in 24h" },
    "Nuova rete casa/ufficio": { prezzo: "preventivo su misura", tempo: "sopralluogo in 24–48h" },
    "Problemi di connessione": { prezzo: "da 40€ a 80€", tempo: "spesso in giornata" },
  },
  "Server / Software aziendale": {
    "Assistenza server": { prezzo: "da 60€/intervento", tempo: "su appuntamento" },
    "Backup e sicurezza": { prezzo: "preventivo su misura", tempo: "analisi in 24h" },
    "Software gestionale": { prezzo: "da 50€/intervento", tempo: "anche da remoto" },
  },
  "Sito Web": {
    "Nuovo sito vetrina": { prezzo: "preventivo su misura", tempo: "2–4 settimane" },
    "Restyling sito esistente": { prezzo: "preventivo su misura", tempo: "1–3 settimane" },
    "Sito lento o problemi tecnici": { prezzo: "da 50€", tempo: "analisi in 24h" },
  },
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
